export const BRIEF_ICON_URL =
    'https://fiverr-res.cloudinary.com/image/upload/v1757408874/listings_assets/lihp/ai_brief_JoP.png';
